import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map } from "lodash";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";
import ReactExport from "react-export-excel";
import { validateRequiredFields } from "../../utils/validation.util";
import { normalizeAmount } from "../../utils/transformer.util";
import { Button, Select, SearchSelect } from "../../components/base/index";

const { ExcelFile } = ReactExport;
const { ExcelSheet, ExcelColumn } = ExcelFile;

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class LaporanJP extends Component {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickNext = this._onClickNext.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    // this._onAddList = this._onAddList.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._getClassesOptions = this._getClassesOptions.bind(this);
    this._handleFormChange = this._handleFormChange.bind(this);
    this._onSearch = this._onSearch.bind(this);
    this._onChangePage = this._onChangePage.bind(this);
    this.onClickCetak = this.onClickCetak.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._getParamPerwakilan = this._getParamPerwakilan.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this._onClickExcel = this._onClickExcel.bind(this);
    // this._getPrmLevels = this._getPrmLevels.bind(this);
    this._initializeData = this._initializeData.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this._onClickSet = this._onClickSet.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;
    this.state = {
      isTable: true,
      page: 1,
      selected: {},
      content: initialContent,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          total_siswa: "",
          classes: [],
          levels_id,
          listsiswa: [],
          classes_id: "",
          user_id: user.id,
          units_id: "",
          perwakilan_id: "",
        },
        error: {
          classes: "",
          levels: "",
          listsiswa: "",
        },
      },
      param: {},
      filtered: false,
      total_siswa: "",
    };
  }

  componentDidMount() {
    const {
      handleGetCodeOfAccount,
      location,
      handleGetClasses,
      handleGetLevels,
      user,
    } = this.props;
    const { school_unit, organizations_id, user_group } = user;
    const { content, filters, form } = this.state;

    let savedFilters =
      JSON.parse(window.localStorage.getItem("jumlahFilters")) || filters;
    let savedForm = JSON.parse(window.localStorage.getItem("jumlahForm")) || "";
    if (savedForm !== "" && user.id !== savedForm.value.user_id) {
      savedForm = "";
      savedFilters = filters;
    }
    this._initializeData(savedFilters);
    if (savedForm !== "") {
      this.setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            levels_id: savedForm.value.levels_id,
            units_id: savedForm.value.units_id,
            classes_id: savedForm.value.classes_id,
            // period: filters.period,
            // update: true,
          },
        },
        filters: {
          ...prevState.filters,
          units_id: savedForm.value.units_id,
        },
      }));
      this._getParamOptionsAcademics("classrooms", {
        levels_id: savedForm.value.levels_id,
        classes_id: savedForm.value.classes_id,
        units_id: savedForm.value.units_id.value,
        organizations_id,
      });

      if (
        user_group.name === "pusat" ||
        user_group.name === "perwakilan" ||
        user_group.name === "pengurus"
      ) {
        this._getClassesOptions({
          filters: {
            levels_id: savedForm.value.levels_id,
            units_id: savedForm.value.units_id.value,
          },
        });
        this._getPeriodsOptions({ units_id: savedForm.value.units_id.value });
        this._getParamPerwakilan();
      }
    }
  }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const paramTypes = ["levels"];
    paramTypes.forEach((type) => {
      this._getParamOptionsAcademics(type);
    });

    if (user_group.name !== "pusat" || user_group.name === "pengurus") {
      // const paramTypes = ["classrooms", "levels"];
      // paramTypes.forEach((type) => {
      //   this._getParamOptionsAcademics(type);
      // });
      this._getClassesOptions({
        filters: { levels_id: [levels_id], units_id: [school_unit.id] },
      });
      await this._getPeriodsOptions({ units_id: school_unit.id });
    }
    if (user_group.name === "perwakilan") {
      await this._getSchoolUnitsOptions({
        perwakilan_id: school_unit.perwakilan_id,
      });
    } else {
      await this._getSchoolUnitsOptions();
      await this._getParamPerwakilan();
    }
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          period: savedFilters.period,
          classrooms_id: savedFilters.classrooms_id,
          // savedFilters
        },
      }),
    );
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find((item) => item.value === units_id);

    // console.log(units_id)
    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : "",
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  onClickCetak() {
    const { history } = this.props;
    history.push("/dashboard/kesiswaan/laporan/daftar-siswa-kelas-unit", {
      isEdit: true,
    });
  }

  _onClickExcel() {
    const { history } = this.props;
    const { form, filters } = this.state;
    history.push(
      "/dashboard/kesiswaan/laporan/daftar-siswa-aktif/cetak-excel",
      {
        isEdit: true,
        data: {
          classes_id: form.value.classes_id,
          classrooms_id: filters.classrooms_id,
        },
      }
    );
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { school_unit, organizations_id } = user;
    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
      // filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  // on formchange untuk form
  _handleFormChange(event) {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      form: {
        value: {
          ...prevState.form.value,
          [name]: value,
        },
        error: {
          ...prevState.form.error,
          [name]: "",
        },
      },
    }));
  }

  _onSearch() {
    const { form } = this.state;
    const error = validateRequiredFields(form.value, ["year"]);
    this.setState((prevState) => ({
      form: {
        value: prevState.form.value,
        error,
      },
    }));
    if (isEmpty(error)) {
      this.setState({ filtered: true });
    }
  }

  async _getParamOptions(type, filters = {}) {
    const { getParamOptions, user } = this.props;
    const { organizations_id } = user;
    if (type === "classes" || type === "classrooms") {
      filters.organizations_id = organizations_id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptions(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _getClassesOptions(filters = {}) {
    const { getClassesOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    // if (user_group.name !== 'pusat'){

    // filters.levels_id = levels_id;
    // filters.units_id = school_unit.id;
    // }
    const res = await getClassesOptions(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        classes_prm: res,
      },
    }));
  }

  async _getParamPerwakilan(filters = {}) {
    const { getParamPerwakilan, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getParamPerwakilan(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        perwakilan_prm: res,
      },
    }));
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions } = this.props;
    const res = await getPeriodsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              periods_id: data.value,
            },
          },
          filters: {
            ...prevState.filters,
            period: data.value,
            period_label: data.label
          },
        }));
      }
    });

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  _onFormChange(event) {
    const { user } = this.props;
    const { organizations_id } = user;
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;

    // Store if we need to clear classrooms_id
    const shouldClearClassroomsId = name === "classes_id";

    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }
          newList = prevState.form.value[fieldName];
          newListError = prevState.form.error[fieldName];
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }

        // Create the new state object
        const newState = {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };

        // If we need to clear classrooms_id, add it to the filters
        if (shouldClearClassroomsId) {
          newState.filters = {
            ...prevState.filters,
            classrooms_id: "",
          };
        }

        return newState;
      },
      () => {

        if (name === "tipe"){
          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                perwakilan_id: value,
                units_id: "",
              },
            },
          }));
        }
        if (name === "classes_id") {
          this._getParamOptionsAcademics("classrooms", {
            classes_id: value,
            organizations_id,
          });
        }
      }
    );
  }

  _onClickAdd() {
    const { form } = this.state;
    const { plafon } = form.value;

    plafon.push({
      tipePlafon: "",
      // divisi: '',
      nominal: 0,
      // period:'',
    });

    this.setState((prevState) => ({
      form: {
        value: {
          ...prevState.form.value,
          plafon,
        },
        error: {
          ...prevState.form.error,
        },
      },
    }));
  }

  async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const { value } = form;
    const { subject_id, classrooms_id, period } = value;
    const { units_id, perwakilan_id } = filters;

    console.log(filters);
    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          const {
            handleReportSchedule,
            handleReportSchPerunit,
            handleReportSchPerwakilan,
            handleReportScheduleNonYayasan,
            handleReportSchPerunitNonYayasan,
            handleReportSchedulePerwakilanNonYayasan,
            handleReportScheduleMoving,
            handleReportSchPerunitMoving,
            handleReportSchedulePerwakilanMoving,
            user,
          } = this.props;
          const { school_unit, workingUnit, id, user_group, organizations_id } =
            user;
          const { levels_id } = school_unit;
          const units =
            user_group.name === "pusat" ||
            user_group.name === "perwakilan" ||
            user_group.name === "pengurus"
              ? units_id.value
              : school_unit.id;
          const perwakilanValue = perwakilan_id ? perwakilan_id.value : "";
          // const perwakilan = user_group.name ===  "perwakilan" ?school_unit.perwakilan_id : perwakilan_id.value;
          let result = {};
          // console.log(form.value.tipe)
          if (form.value.tipe == 0) {
            if (!units_id && filters.period !== "undefined") {
              console.log("test 1");

              result = await handleReportSchedule({
                ...params,
                organizations_id,
                units_id: units,
                period: filters.period,
                period_label: filters.period_label,
                filters,
              });
            } else if (units_id.value !== "all") {
              console.log("test 2");
              result = await handleReportSchedule({
                ...params,
                organizations_id,
                units_id: units,
                period: filters.period,
                period_label: filters.period_label,
                filters,
              });
            } else if (perwakilanValue === "all" && units_id.value === "all") {
              result = await handleReportSchPerwakilan({
                ...params,
                organizations_id,
                units_id: units,
                period: filters.period,
                filters,
              });
            } else if (units_id.value === "all") {
              console.log("test 3");
              result = await handleReportSchPerunit({
                ...params,
                organizations_id,
                period: filters.period,
                perwakilan_id:
                  user_group.name === "perwakilan"
                    ? school_unit.perwakilan_id
                    : perwakilanValue,
                filters,
              });
            }
          }
          if(form.value.tipe == 1) {
             if (!units_id && filters.period !== "undefined") {
              console.log("test 1");

              result = await handleReportScheduleNonYayasan({
                ...params,
                organizations_id,
                units_id: units,
                period: filters.period,
                period_label: filters.period_label,
                filters,
              });
            } else if (units_id.value !== "all") {
              console.log("test 2");
              result = await handleReportScheduleNonYayasan({
                ...params,
                organizations_id,
                units_id: units,
                period: filters.period,
                period_label: filters.period_label,
                filters,
              });
            } else if (perwakilanValue === "all" && units_id.value === "all") {
              result = await handleReportSchedulePerwakilanNonYayasan({
                ...params,
                organizations_id,
                units_id: units,
                period: filters.period,
                filters,
              });
            } else if (units_id.value === "all") {
              console.log("test 3");
              result = await handleReportSchPerunitNonYayasan({
                ...params,
                organizations_id,
                period: filters.period,
                perwakilan_id:
                  user_group.name === "perwakilan"
                    ? school_unit.perwakilan_id
                    : perwakilanValue,
                filters,
              });
            }
          }
          if(form.value.tipe == 2) {
             if (!units_id && filters.period !== "undefined") {
              console.log("test 1");

              result = await handleReportScheduleMoving({
                ...params,
                organizations_id,
                units_id: units,
                period: filters.period,
                period_label: filters.period_label,
                filters,
              });
            } else if (units_id.value !== "all") {
              console.log("test 2");
              result = await handleReportScheduleMoving({
                ...params,
                organizations_id,
                units_id: units,
                period: filters.period,
                period_label: filters.period_label,
                filters,
              });
            } else if (perwakilanValue === "all" && units_id.value === "all") {
              result = await handleReportSchedulePerwakilanMoving({
                ...params,
                organizations_id,
                units_id: units,
                period: filters.period,
                filters,
              });
            } else if (units_id.value === "all") {
              console.log("test 3");
              result = await handleReportSchPerunitMoving({
                ...params,
                organizations_id,
                period: filters.period,
                perwakilan_id:
                  user_group.name === "perwakilan"
                    ? school_unit.perwakilan_id
                    : perwakilanValue,
                filters,
              });
            }
          }

          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listsiswa: result,
              },
            },
          }));
        } catch (err) {
          // if (this.isMount) {
          console.log("masuk C");
          console.log(err);
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listsiswa: [],
              },
            },
          }));
        }
        // }
      }
    );
  }

  // on formchange untuk tabel
  onFormChange(event) {
    const { name, value, dataset } = event.target;
    const {
      inputArray = false,
      arrayPosition = 0,
      inputType = "text",
    } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      let newPlafon = [];
      if (inputType === "number") {
        formattedValue = normalizeAmount(value);
      }

      if (inputArray) {
        newPlafon = prevState.form.value.plafon;
        newPlafon[arrayPosition][name] = value;
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { plafon: newPlafon }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            form: "",
            [name]: "",
          },
        },
      };
    });
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    this.setState(
      (prevState) => {
  let newFilters = {
    ...prevState.filters,
    [name]: value,
  };

  if (name === "period") {
    const selected = prevState.param.periods.find(
      (i) => i.value == value
    );

    newFilters.period_label = selected ? selected.label : "";
  }

  return {
    ...prevState,
    filters: newFilters,
  };
},
      () => {
        window.localStorage.setItem(
          "jumlahFilters",
          JSON.stringify(this.state.filters)
        );
        window.localStorage.setItem(
          "jumlahForm",
          JSON.stringify(this.state.form)
        );
        if (
          (name === "period" && user_group.name !== "pusat") ||
          user_group.name !== "pengurus"
        ) 


        if (name === "perwakilan_id") {
          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                perwakilan_id: value,
                units_id: "",
              },
            },
          }));
          this._getSchoolUnitsOptions({ perwakilan_id: value.value });
          // if(value.value ===  'all'){
          // this._onSearchContent();
          // }
        }
        if (name === "units_id") {
          const param = this.state.param.units;
          const levels_units = param.find((i) => i.value === value.value)
            ? param.find((i) => i.value === value.value).attributes.levels_id
            : "";

          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                classrooms_id: "",
                levels_id: levels_units,
                units_id: value,
              },
            },
            filters: {
              ...prevState.filters,
              period: "",
            },
          }));
          this._getParamOptionsAcademics("classrooms", {
            levels_id: levels_units,
            organizations_id,
            units_id: value.value,
          });
          this._getClassesOptions({
            filters: { levels_id: [levels_units], units_id: [value.value] },
          });

          this._getPeriodsOptions({ units_id: value.value });
        }

      }
    );
  }

  _onClickSet() {
    const { form, filters } = this.state;
    const { value } = form;
    let error = {};

    error = validateRequiredFields(filters, ["date", "date_to"]);

    // if (isEmpty(error)) {
    this.setState(
      (prevState) => ({
        ...prevState,
        isTable: false,
        filters: {
          ...prevState.filters,
        },
      }),
      () => {
        this._onSearchContent();
      }
    );
  }
  // }

  _onChangePage(page) {
    const { listAmount, keywords } = this.state;
    const offset = listAmount * (page - 1);
    // this.handleGetData({
    this._onSearchContent({
      limit: listAmount,
      keywords,
      offset,
      page,
    });
  }

  _onClickNext() {
    window.scrollTo(0, 0);
    this.setState((prevState) => ({
      page: prevState.page + 1,
    }));
  }

  onClickEdit(val) {
    const { history } = this.props;
    history.push("/dashboard/kesiswaan/pendaftaran", {
      data: val,
      isEdit: true,
    });
  }

  _renderButtons(data) {
    const { user } = this.props;
    const { user_group } = user;
    const button = {};

    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onClickEdit(data)} title="Edit" />
        </div>
      </td>
    );
  }



  renderExcel(listsiswa) {
    const { form } = this.state;
    const { value } = form;

    const excelTbl = [];
    map(listsiswa, (list, idx) => {
      const items = Object.create({});
      items.name = list.name;
      items.unit_code = list.unit_code;
      items.total_student = list.total_student;

      excelTbl.push(items);
    });

    const rows = [];
    rows.push([
      form.value.units_id.value === "all" ? (
        <ExcelFile
          element={
            <Button style={{ height: 30, width: 400, marginRight: 9 }}>
              {" "}
              Ekspor Excel
            </Button>
          }
        >
          <ExcelSheet data={excelTbl} name="excel">
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Kelas"
              value="name"
            />
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Kode Unit"
              value="unit_code"
            />
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Jumlah Siswa"
              value="total_student"
            />
          </ExcelSheet>
        </ExcelFile>
      ) : (
        <ExcelFile
          element={
            <Button style={{ height: 30, width: 400, marginRight: 9 }}>
              {" "}
              Ekspor Excel
            </Button>
          }
        >
          <ExcelSheet data={excelTbl} name="excel">
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Kelas"
              value="name"
            />
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Jumlah Siswa"
              value="total_student"
            />
          </ExcelSheet>
        </ExcelFile>
      ),
    ]);
    return rows;
  }

  render() {
    const { param, form, filters, isTable } = this.state;
    const { listsiswa } = form.value;
    const { period = "" } = filters;
    const { user } = this.props;
    const { school_unit, user_group } = user;

    const All = [{ value: "all", label: "Semua Perwakilan", attributes: {} }];
    const AllUnit = [{ value: "all", label: "Semua Unit", attributes: {} }];
    const tipe_staff = [
        { value: '0', label: 'Yayasan' },
        { value: '1', label: 'Non Yayasan' },
        { value: '2', label: 'Moving' }
      ];
    let total = 0;
    let totalres = 0;
    // console.log(listsiswa)

    const componentRef = React.createRef();
    const printTest = `
    @media print {
      @page {
        page-break-inside: avoid;
      }
      * {
        -webkit-print-color-adjust: exact;
      }
    }`;

    const units_label = filters.units_id ? filters.units_id.label : "";

    const prm_period = param.periods ? param.periods : "";
    const prm_units = param.units ? param.units : "";
    const prm_perwakilan = param.perwakilan_prm ? param.perwakilan_prm : "";
    const period_label = prm_period
      ? prm_period.find((i) => i.value == period)
        ? prm_period.find((i) => i.value == period).label
        : ""
      : "";
    const units_all = [...AllUnit, ...prm_units];
    const perwakilan_all = [...All, ...prm_perwakilan];
    const years = [];
    const thisyear = new Date().getFullYear();
    for (let i = 2021; i <= thisyear; i++) {
      const nextyear = Number(i) + 1;
      years.push({
        label: `${i}-${nextyear}`,
        value: i,
      });
    }

    const period_label_all = years.find((i) => i.value == period)
      ? years.find((i) => i.value == period).label
      : "";
      console.log(form.value.tipe)
    return (
      <div className="manage-registration">
        <h1>Laporan Waktu Mengajar</h1>
        <div className="absensi-rekap__custom-form">
           <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                    <Select
                      name="tipe"
                      label="Pilih Tipe Pegawai"
                      onChange={this._onFormChange}
                      data={tipe_staff}
                      placeholder="Pilihan"
                      value={form.value.tipe}
                    />
                </div>
              </div>
          {user_group.name === "pusat" ||
          user_group.name === "perwakilan" ||
          user_group.name === "pengurus" ? (
            <div>
              <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                  {user_group.name === "pusat" ||
                  user_group.name === "pengurus" ? (
                    <SearchSelect
                      noMargin
                      async={false}
                      name="perwakilan_id"
                      list={perwakilan_all}
                      inputArray
                      onClick={this._onChangeFilter}
                      placeholder="Pilih Perwakilan"
                      value={form.value.perwakilan_id}
                      rightIcon="icon-search"
                      label="Pilih Perwakilan"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                  <SearchSelect
                    noMargin
                    async={false}
                    name="units_id"
                    list={units_all}
                    inputArray
                    onClick={this._onChangeFilter}
                    placeholder="Pilih Unit"
                    value={form.value.units_id}
                    rightIcon="icon-search"
                    label="Pilih Unit"
                  />
                </div>
                <div className="absensi-rekap__custom-form-column__field">
                  <Select
                    name="period"
                    label="Tahun Ajaran"
                    onChange={this._onChangeFilter}
                    data={
                      form.value.units_id.value === "all"
                        ? years
                        : param.periods
                    }
                    placeholder="Pilihan"
                    value={period}
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                  <Select
                    name="period"
                    label="Tahun Ajaran"
                    onChange={this._onChangeFilter}
                    data={param.periods}
                    placeholder="Pilihan"
                    value={period}
                  />
                </div>
                <div className="absensi-rekap__custom-form-column__field">
                  <Select
                    type="text"
                    name="levels_id"
                    label="Unit"
                    placeholder="Pilih Unit"
                    data={param.levels}
                    onChange={this._onFormChange}
                    value={form.value.levels_id}
                    disabled
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <div>
          <Button title="Proses" onClick={this._onClickSet} />
        </div>
        <br></br>
        <div className="beginning-balance__button-wrapper">
          <ReactToPrint
            pageStyle={printTest}
            onBeforeGetContent={() =>
              new Promise((resolve) => {
                setTimeout(() => {
                  this.setState({ isPrint: false }, resolve);
                }, 500);
              })
            }
            onAfterPrint={() => this.setState({ isPrint: true })}
            trigger={() => <Button title="Cetak" />}
            content={() => componentRef.current}
          />
          {/* <Button
              title="Ekspor Excel"
              onClick={this._onClickExcel}
            /> */}
          &nbsp;
          <div style={{ marginLeft: "0rem" }} className="student-list__button">
            <ReactHTMLTableToExcel
              id="export-to-xls-button"
              className="button "
              table="printable"
              filename={`Jumlah Siswa Semua Perwakilan Tahun ajaran ${period_label_all}`}
              sheet={period_label_all}
              buttonText="Unduh ke Excel"
            />
          </div>
        </div>
        {!isTable && (
          ((form.value.tipe == 0)||(form.value.tipe == 2)) && (
          <form
            style={{ pageBreakInside: "avoid", paddingTop: "20px" }}
            ref={componentRef}
          >
            <div className="manage-registration">
              <table
                className="laporan-ki4__table-test"
                style={{ width: "unset" }}
              ></table>
              <div className="fund-request__content">
                {form.value.perwakilan_id.value === "all" && (
                  <table
                    className="table"
                    id="printable"
                    ref={componentRef}
                    style={{ textAlign: "center" }}
                  >
                    <thead>
                      <tr className="grey">
                        <th>Kode Unit</th>
                        <th>Nama Unit</th>
                        <th>Kode Guru</th>
                        <th>NIP</th>
                        <th>Nama Guru</th>
                        <th>Jabatan</th>
                        {form.value.tipe == 0?
                        <>
                        <th>Jumlah Mengajar</th>
                        <th>Wajib Mengajar</th>
                        <th>Kelmeng</th>
                        <th>Unit</th>
                        </>:''}
                        <th>Mengampu</th>
                        <th>JP</th>
                        <th>Total</th>
                      </tr>
                    </thead>

                    <tbody>
                      {map(listsiswa, (list, listIdx) => (
                        <React.Fragment key={listIdx}>
                          {/* HEADER PER UNIT */}
                          <tr>
                            <td
                              colSpan={form.value.tipe == 2 ? 10 : 12}
                              style={{ fontWeight: "bold" }}
                            >
                              {list.name}
                            </td>
                          </tr>

                          {map(list.body, (body, bodyIdx) => {
                            const hasData = body.res && body.res.length > 0;

                            if (!hasData) {
                              return (
                                <tr key={bodyIdx}>
                                  <td>{body.unit_code}</td>
                                  <td>{body.name}</td>
                                  <td
                                    colSpan={
                                      form.value.tipe == 2 ? 7 : 10
                                    }
                                  >
                                    Data Belum Ada
                                  </td>
                                </tr>
                              );
                            }

                            return body.res.map((res, resIdx) => {
                              const hasDetail =
                                res.details &&
                                Array.isArray(res.details) &&
                                res.details.length > 0;

                              const detailCount = hasDetail
                                ? res.details.length
                                : 1;

                              const totalJP = hasDetail
                                ? res.details.reduce(
                                    (s, d) => s + Number(d.ttl_mapel || 0),
                                    0
                                  )
                                : 0;
                              const rowSpan = Math.max(detailCount, 1);

                              const firstDetail =
                                hasDetail &&
                                res.details[0] &&
                                res.details[0].mapel_name
                                  ? res.details[0]
                                  : null;

                              return (
                                <React.Fragment key={`${bodyIdx}-${resIdx}`}>
                                  {/* BARIS PERTAMA */}
                                  <tr>
                                    {resIdx === 0 && (
                                      <>
                                        <td
                                          rowSpan={body.res.reduce((a, b) => {
                                            const len =
                                              b.details && b.details.length
                                                ? b.details.length
                                                : 1;
                                            return a + len;
                                          }, 0)}
                                        >
                                          {body.unit_code}
                                        </td>
                                        <td
                                          rowSpan={body.res.reduce((a, b) => {
                                            const len =
                                              b.details && b.details.length
                                                ? b.details.length
                                                : 1;
                                            return a + len;
                                          }, 0)}
                                        >
                                          {body.name}
                                        </td>
                                      </>
                                    )}

                                    <td rowSpan={rowSpan}>{res.code}</td>
                                    <td rowSpan={rowSpan}>{res.staff_nip}</td>
                                    <td rowSpan={rowSpan}>{res.staff_name}</td>
                                    <td rowSpan={rowSpan}>
                                      {res.position_name}
                                    </td>
                                    {form.value.tipe == 0?
                                    <>
                                    <td rowSpan={rowSpan}>{res.jp}</td>
                                    <td rowSpan={rowSpan}>
                                      {res.wajib_mengajar}
                                    </td>
                                    <td rowSpan={rowSpan}>{res.kelmeng}</td>
                                    </>
                                    :''}
                                    {/* MAPEL PERTAMA */}
                                    <td>
                                      {firstDetail
                                        ? firstDetail.unit_code
                                        : "-"}
                                    </td>
                                    <td>
                                      {firstDetail
                                        ? firstDetail.mapel_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {firstDetail
                                        ? firstDetail.ttl_mapel
                                        : "-"}
                                    </td>
                                    {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                    <td
                                      rowSpan={detailCount}
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {totalJP || "-"}
                                    </td>
                                  </tr>

                                  {/* MAPEL LANJUTAN */}
                                  {hasDetail &&
                                    res.details.slice(1).map((dtl, i) =>
                                      dtl && dtl.mapel_name ? (
                                        <tr key={i}>
                                          <td>{dtl.unit_code}</td>
                                          <td>{dtl.mapel_name}</td>
                                          <td>{dtl.ttl_mapel}</td>
                                        </tr>
                                      ) : null
                                    )}
                                </React.Fragment>
                              );
                            });
                          })}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                )}
                {form.value.perwakilan_id.value !== "all" &&
                  form.value.units_id.value === "all" && (
                    <table
                      className="table"
                      id="printable"
                      ref={componentRef}
                      style={{ textAlign: "center" }}
                    >
                      <thead>
                        <tr className="grey">
                          <th>Kode Unit</th>
                          <th>Nama Unit</th>
                          <th>Kode Guru</th>
                          <th>NIP</th>
                          <th>Nama Guru</th>
                          <th>Jabatan</th>
                          {form.value.tipe == 0?
                          <>
                          <th>Jumlah Mengajar</th>
                          <th>Wajib Mengajar</th>
                          <th>Kelmeng</th>
                          <th>Unit</th>
                          </>:''}
                          <th>Mengampu</th>
                          <th>JP</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(listsiswa, (list, listIdx) => {
                          const hasData = list.res && list.res.length > 0;

                          if (!hasData) {
                            return (
                              <tr key={listIdx}>
                                <td>{list.unit_code}</td>
                                <td>{list.name}</td>
                                <td colSpan={form.value.tipe == 2? 7 : 10}>Data Belum Ada</td>
                              </tr>
                            );
                          }
                          return list.res.map((res, resIdx) => {
                            const hasDetail =
                              res.details &&
                              Array.isArray(res.details) &&
                              res.details.length > 0;

                            const detailCount = hasDetail
                              ? res.details.length
                              : 1;

                            const totalJP = hasDetail
                              ? res.details.reduce(
                                  (s, d) => s + Number(d.ttl_mapel || 0),
                                  0
                                )
                              : 0;

                            const rowSpan = Math.max(detailCount, 1);

                            const firstDetail =
                              hasDetail &&
                              res.details[0] &&
                              res.details[0].mapel_name
                                ? res.details[0]
                                : null;
                            return (
                              <React.Fragment key={`${listIdx}-${resIdx}`}>
                                <tr>
                                  {resIdx === 0 && (
                                    <>
                                      <td
                                        rowSpan={list.res.reduce((a, b) => {
                                          const len =
                                            b.details && b.details.length
                                              ? b.details.length
                                              : 1;
                                          return a + len;
                                        }, 0)}
                                      >
                                        {list.unit_code}
                                      </td>
                                      <td
                                        rowSpan={list.res.reduce((a, b) => {
                                          const len =
                                            b.details && b.details.length
                                              ? b.details.length
                                              : 1;
                                          return a + len;
                                        }, 0)}
                                      >
                                        {list.name}
                                      </td>
                                    </>
                                  )}
                                  <td rowSpan={rowSpan}>{res.code}</td>
                                  <td rowSpan={rowSpan}>{res.staff_nip}</td>
                                  <td rowSpan={rowSpan}>{res.staff_name}</td>
                                  <td rowSpan={rowSpan}>{res.position_name}</td>
                                  {form.value.tipe == 0?
                                  <>
                                  <td rowSpan={rowSpan}>{res.jp}</td>
                                  <td rowSpan={rowSpan}>
                                    {res.wajib_mengajar}
                                  </td>
                                  <td rowSpan={rowSpan}>{res.kelmeng}</td>
                                  {/* MAPEL PERTAMA */}
                                  </>:''}
                                  <td>
                                    {firstDetail ? firstDetail.unit_code : "-"}
                                  </td>
                                  <td>
                                    {firstDetail ? firstDetail.mapel_name : "-"}
                                  </td>
                                  <td>
                                    {firstDetail ? firstDetail.ttl_mapel : "-"}
                                  </td>
                                  {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                  <td
                                    rowSpan={detailCount}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {totalJP || "-"}
                                  </td>
                                </tr>

                                {/* MAPEL LANJUTAN */}
                                {hasDetail &&
                                  res.details.slice(1).map((dtl, i) =>
                                    dtl && dtl.mapel_name ? (
                                      <tr key={i}>
                                        <td>{dtl.unit_code}</td>
                                        <td>{dtl.mapel_name}</td>
                                        <td>{dtl.ttl_mapel}</td>
                                      </tr>
                                    ) : null
                                  )}
                              </React.Fragment>
                            );
                          });

                          {
                            /* <tr>
                                <td
                                  rowSpan={list.res ? list.res.length + 1 : 1}
                                >
                                  {list.unit_code}
                                </td>
                                <td
                                  rowSpan={list.res ? list.res.length + 1 : 1}
                                >
                                  {list.name}
                                </td>
                                {list.res ? (
                                  list.res.length == 0 ? (
                                    <td colSpan={10}>Data Belum Ada</td>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                              </tr> */
                          }
                          // {list.res && list.res.length > 0
                          //   ? map(list.res, (res, resIdx) => (
                          //       <tr key={`budget_row_${listIdx}_${resIdx}`}>
                          //         <td>{res.code}</td>
                          //         <td>{res.staff_nip}</td>
                          //         <td>{res.staff_name}</td>
                          //         <td>{res.position_name}</td>
                          //         <td>{res.jp}</td>
                          //         <td>{res.wajib_mengajar}</td>
                          //         <td>{res.kelmeng}</td>
                          //       </tr>
                          //     ))
                          //   : ""}
                        })}
                      </tbody>
                    </table>
                  )}
                {form.value.units_id.value !== "all" && (
                  <table
                    className="table"
                    id="printable"
                    ref={componentRef}
                    style={{ textAlign: "center" }}
                  >
                    <thead>
                      <tr className="grey">
                        <th>Kode Guru</th>
                        <th>NIP</th>
                        <th>Nama</th>
                        <th>Jabatan</th>
                         {form.value.tipe == 0?
                          <>
                          <th>Jumlah Mengajar</th>
                          <th>Wajib Mengajar</th>
                          <th>Kelmeng</th>
                          <th>Unit</th>
                          </>:''}
                        <th>Mengampu</th>
                        <th>JP</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listsiswa.length > 0 ? (
                        <>
                          {map(listsiswa, (list, listIdx) => {
                            console.log(list.details)
                            const hasDetail =
                              list.details &&
                              Array.isArray(list.details) &&
                              list.details.length > 0;

                            const detailCount = hasDetail
                              ? list.details.length
                              : 1;

                            const totalJP = hasDetail
                              ? list.details.reduce(
                                  (s, d) => s + Number(d.ttl_mapel || 0),
                                  0
                                )
                              : 0;

                            const rowSpan = Math.max(detailCount, 1);
                            const firstDetail =
                              hasDetail &&
                              list.details[0] &&
                              list.details[0].mapel_name
                                ? list.details[0]
                                : null;
                            return (
                              <React.Fragment key={`${listIdx}`}>
                                <tr>
                                  <td rowSpan={rowSpan}>{list.code}</td>
                                  <td rowSpan={rowSpan}>{list.staff_nip}</td>
                                  <td rowSpan={rowSpan}>{list.staff_name}</td>
                                  <td rowSpan={rowSpan}>
                                    {list.position_name}
                                  </td>
                                    {form.value.tipe == 0?
                                  <>
                                  <td rowSpan={rowSpan}>{list.jp}</td>
                                  <td rowSpan={rowSpan}>
                                    {list.wajib_mengajar}
                                  </td>
                                  <td rowSpan={rowSpan}>{list.kelmeng}</td>
                                  {/* MAPEL PERTAMA */}
                                  </>:''}
                                  {/* MAPEL PERTAMA */}
                                  <td>
                                    {firstDetail ? firstDetail.unit_code : "-"}
                                  </td>
                                  <td>
                                    {firstDetail ? firstDetail.mapel_name : "-"}
                                  </td>
                                  <td>
                                    {firstDetail ? firstDetail.ttl_mapel : "-"}
                                  </td>
                                  {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                  <td
                                    rowSpan={detailCount}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {totalJP || "-"}
                                  </td>
                                </tr>

                                 {/* MAPEL LANJUTAN */}
                                {hasDetail &&
                                  list.details.slice(1).map((dtl, i) =>
                                    dtl && dtl.mapel_name ? (
                                      <tr key={i}>
                                        <td>{dtl.unit_code}</td>
                                        <td>{dtl.mapel_name}</td>
                                        <td>{dtl.ttl_mapel}</td>
                                      </tr>
                                    ) : null
                                  )}
                              </React.Fragment>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={form.value.tipe == 2? 7 : 10}>Data Belum Ada</td>
                        </tr>
                      )}
                    </tbody>
                    {/* {listsiswa.length > 0 ? (
                      // Calculate total classes for this perwakilan
                      map(listsiswa, (list, idx) => (
                        <>
                          <tbody>
                            <tr key={`budget_row_${idx}`}>
                              <td>{list.code}</td>
                              <td>{list.staff_nip}</td>
                              <td>{list.staff_name}</td>
                              <td>{list.position_name}</td>
                              <td>{list.jp}</td>
                              <td>{list.wajib_mengajar}</td>
                              <td>{list.kelmeng}</td>
                              {list.details.length > 0
                                ? map(list.details, (dtl, idx) => (
                                    <>
                                      <td>{dtl.mapel_name}</td>
                                      <td>{dtl.ttl_mapel}</td>
                                    </>
                                  ))
                                : ""}
                            </tr>
                          </tbody>
                        </>
                      ))
                    ) : (
                      <td colSpan={7}>Data Belum Ada</td>
                    )} */}
                  </table>
                )}
              </div>
            </div>
          </form>
          ))}
           {!isTable && (
          (form.value.tipe == 1) && (
          <form
            style={{ pageBreakInside: "avoid", paddingTop: "20px" }}
            ref={componentRef}
          >
            <div className="manage-registration">
              <table
                className="laporan-ki4__table-test"
                style={{ width: "unset" }}
              ></table>
              <div className="fund-request__content">
                {form.value.perwakilan_id.value === "all" && (
                  <table
                    className="table"
                    id="printable"
                    ref={componentRef}
                    style={{ textAlign: "center" }}
                  >
                    <thead>
                      <tr className="grey">
                        <th>Kode Unit</th>
                        <th>Nama Unit</th>
                        <th>Kode Guru</th>
                        <th>Nama Guru</th>
                        <th>Mengampu</th>
                        <th>JP</th>
                        <th>Total</th>
                      </tr>
                    </thead>

                    <tbody>
                      {map(listsiswa, (list, listIdx) => (
                        <React.Fragment key={listIdx}>
                          {/* HEADER PER UNIT */}
                          <tr>
                            <td colSpan={12} style={{ fontWeight: "bold" }}>
                              {list.name}
                            </td>
                          </tr>

                          {map(list.body, (body, bodyIdx) => {
                            const hasData = body.res && body.res.length > 0;

                            if (!hasData) {
                              return (
                                <tr key={bodyIdx}>
                                  <td>{body.unit_code}</td>
                                  <td>{body.name}</td>
                                  <td colSpan={7}>Data Belum Ada</td>
                                </tr>
                              );
                            }

                            return body.res.map((res, resIdx) => {
                              const hasDetail =
                                res.details &&
                                Array.isArray(res.details) &&
                                res.details.length > 0;

                              const detailCount = hasDetail
                                ? res.details.length
                                : 1;

                              const totalJP = hasDetail
                                ? res.details.reduce(
                                    (s, d) => s + Number(d.ttl_mapel || 0),
                                    0
                                  )
                                : 0;
                              const rowSpan = Math.max(detailCount, 1);

                              const firstDetail =
                                hasDetail &&
                                res.details[0] &&
                                res.details[0].mapel_name
                                  ? res.details[0]
                                  : null;

                              return (
                                <React.Fragment key={`${bodyIdx}-${resIdx}`}>
                                  {/* BARIS PERTAMA */}
                                  <tr>
                                    {resIdx === 0 && (
                                      <>
                                        <td
                                          rowSpan={body.res.reduce((a, b) => {
                                            const len =
                                              b.details && b.details.length
                                                ? b.details.length
                                                : 1;
                                            return a + len;
                                          }, 0)}
                                        >
                                          {body.unit_code}
                                        </td>
                                        <td
                                          rowSpan={body.res.reduce((a, b) => {
                                            const len =
                                              b.details && b.details.length
                                                ? b.details.length
                                                : 1;
                                            return a + len;
                                          }, 0)}
                                        >
                                          {body.name}
                                        </td>
                                      </>
                                    )}

                                    <td rowSpan={rowSpan}>{res.code}</td>
                                    <td rowSpan={rowSpan}>{res.staff_name}</td>
                                    {/* MAPEL PERTAMA */}
                                    <td>
                                      {firstDetail
                                        ? firstDetail.mapel_name
                                        : "-"}
                                    </td>
                                    <td>
                                      {firstDetail
                                        ? firstDetail.ttl_mapel
                                        : "-"}
                                    </td>
                                    {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                    <td
                                      rowSpan={detailCount}
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {totalJP || "-"}
                                    </td>
                                  </tr>

                                  {/* MAPEL LANJUTAN */}
                                  {hasDetail &&
                                    res.details.slice(1).map((dtl, i) =>
                                      dtl && dtl.mapel_name ? (
                                        <tr key={i}>
                                          <td>{dtl.mapel_name}</td>
                                          <td>{dtl.ttl_mapel}</td>
                                        </tr>
                                      ) : null
                                    )}
                                </React.Fragment>
                              );
                            });
                          })}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                )}
                {form.value.perwakilan_id.value !== "all" &&
                  form.value.units_id.value === "all" && (
                    <table
                      className="table"
                      id="printable"
                      ref={componentRef}
                      style={{ textAlign: "center" }}
                    >
                      <thead>
                        <tr className="grey">
                          <th>Kode Unit</th>
                          <th>Nama Unit</th>
                          <th>Kode Guru</th>
                          <th>Nama Guru</th>
                          <th>Mengampu</th>
                          <th>JP</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(listsiswa, (list, listIdx) => {
                          const hasData = list.res && list.res.length > 0;

                          if (!hasData) {
                            return (
                              <tr key={listIdx}>
                                <td>{list.unit_code}</td>
                                <td>{list.name}</td>
                                <td colSpan={7}>Data Belum Ada</td>
                              </tr>
                            );
                          }
                          return list.res.map((res, resIdx) => {
                            const hasDetail =
                              res.details &&
                              Array.isArray(res.details) &&
                              res.details.length > 0;

                            const detailCount = hasDetail
                              ? res.details.length
                              : 1;

                            const totalJP = hasDetail
                              ? res.details.reduce(
                                  (s, d) => s + Number(d.ttl_mapel || 0),
                                  0
                                )
                              : 0;

                            const rowSpan = Math.max(detailCount, 1);

                            const firstDetail =
                              hasDetail &&
                              res.details[0] &&
                              res.details[0].mapel_name
                                ? res.details[0]
                                : null;
                            return (
                              <React.Fragment key={`${listIdx}-${resIdx}`}>
                                <tr>
                                  {resIdx === 0 && (
                                    <>
                                      <td
                                        rowSpan={list.res.reduce((a, b) => {
                                          const len =
                                            b.details && b.details.length
                                              ? b.details.length
                                              : 1;
                                          return a + len;
                                        }, 0)}
                                      >
                                        {list.unit_code}
                                      </td>
                                      <td
                                        rowSpan={list.res.reduce((a, b) => {
                                          const len =
                                            b.details && b.details.length
                                              ? b.details.length
                                              : 1;
                                          return a + len;
                                        }, 0)}
                                      >
                                        {list.name}
                                      </td>
                                    </>
                                  )}
                                  <td rowSpan={rowSpan}>{res.code}</td>
                                  <td rowSpan={rowSpan}>{res.staff_name}</td>
                                  {/* MAPEL PERTAMA */}
                                  <td>
                                    {firstDetail ? firstDetail.mapel_name : "-"}
                                  </td>
                                  <td>
                                    {firstDetail ? firstDetail.ttl_mapel : "-"}
                                  </td>
                                  {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                  <td
                                    rowSpan={detailCount}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {totalJP || "-"}
                                  </td>
                                </tr>

                                {/* MAPEL LANJUTAN */}
                                {hasDetail &&
                                  res.details.slice(1).map((dtl, i) =>
                                    dtl && dtl.mapel_name ? (
                                      <tr key={i}>
                                        <td>{dtl.mapel_name}</td>
                                        <td>{dtl.ttl_mapel}</td>
                                      </tr>
                                    ) : null
                                  )}
                              </React.Fragment>
                            );
                          });

                          {
                            /* <tr>
                                <td
                                  rowSpan={list.res ? list.res.length + 1 : 1}
                                >
                                  {list.unit_code}
                                </td>
                                <td
                                  rowSpan={list.res ? list.res.length + 1 : 1}
                                >
                                  {list.name}
                                </td>
                                {list.res ? (
                                  list.res.length == 0 ? (
                                    <td colSpan={10}>Data Belum Ada</td>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                              </tr> */
                          }
                          // {list.res && list.res.length > 0
                          //   ? map(list.res, (res, resIdx) => (
                          //       <tr key={`budget_row_${listIdx}_${resIdx}`}>
                          //         <td>{res.code}</td>
                          //         <td>{res.staff_nip}</td>
                          //         <td>{res.staff_name}</td>
                          //         <td>{res.position_name}</td>
                          //         <td>{res.jp}</td>
                          //         <td>{res.wajib_mengajar}</td>
                          //         <td>{res.kelmeng}</td>
                          //       </tr>
                          //     ))
                          //   : ""}
                        })}
                      </tbody>
                    </table>
                  )}
                {form.value.units_id.value !== "all" && (
                  <table
                    className="table"
                    id="printable"
                    ref={componentRef}
                    style={{ textAlign: "center" }}
                  >
                    <thead>
                      <tr className="grey">
                        <th>Kode Guru</th>
                        <th>Nama</th>
                        <th>Mengampu</th>
                        <th>JP</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listsiswa.length > 0 ? (
                        <>
                          {map(listsiswa, (list, listIdx) => {
                            console.log(list.details)
                            const hasDetail =
                              list.details &&
                              Array.isArray(list.details) &&
                              list.details.length > 0;

                            const detailCount = hasDetail
                              ? list.details.length
                              : 1;

                            const totalJP = hasDetail
                              ? list.details.reduce(
                                  (s, d) => s + Number(d.ttl_mapel || 0),
                                  0
                                )
                              : 0;

                            const rowSpan = Math.max(detailCount, 1);
                            const firstDetail =
                              hasDetail &&
                              list.details[0] &&
                              list.details[0].mapel_name
                                ? list.details[0]
                                : null;
                            return (
                              <React.Fragment key={`${listIdx}`}>
                                <tr>
                                  <td rowSpan={rowSpan}>{list.code}</td>
                                  <td rowSpan={rowSpan}>{list.staff_name}</td>
                                  {/* MAPEL PERTAMA */}
                                  <td>
                                    {firstDetail ? firstDetail.mapel_name : "-"}
                                  </td>
                                  <td>
                                    {firstDetail ? firstDetail.ttl_mapel : "-"}
                                  </td>
                                  {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                  <td
                                    rowSpan={detailCount}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {totalJP || "-"}
                                  </td>
                                </tr>

                                 {/* MAPEL LANJUTAN */}
                                {hasDetail &&
                                  list.details.slice(1).map((dtl, i) =>
                                    dtl && dtl.mapel_name ? (
                                      <tr key={i}>
                                        <td>{dtl.mapel_name}</td>
                                        <td>{dtl.ttl_mapel}</td>
                                      </tr>
                                    ) : null
                                  )}
                              </React.Fragment>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={5}>Data Belum Ada</td>
                        </tr>
                      )}
                    </tbody>
                    {/* {listsiswa.length > 0 ? (
                      // Calculate total classes for this perwakilan
                      map(listsiswa, (list, idx) => (
                        <>
                          <tbody>
                            <tr key={`budget_row_${idx}`}>
                              <td>{list.code}</td>
                              <td>{list.staff_nip}</td>
                              <td>{list.staff_name}</td>
                              <td>{list.position_name}</td>
                              <td>{list.jp}</td>
                              <td>{list.wajib_mengajar}</td>
                              <td>{list.kelmeng}</td>
                              {list.details.length > 0
                                ? map(list.details, (dtl, idx) => (
                                    <>
                                      <td>{dtl.mapel_name}</td>
                                      <td>{dtl.ttl_mapel}</td>
                                    </>
                                  ))
                                : ""}
                            </tr>
                          </tbody>
                        </>
                      ))
                    ) : (
                      <td colSpan={7}>Data Belum Ada</td>
                    )} */}
                  </table>
                )}
              </div>
            </div>
          </form>
          )
        )}
      </div>
    );
  }
}
LaporanJP.propTypes = {
  user: PropTypes.object.isRequired,
  handleGetCodeOfAccount: PropTypes.func,
  location: PropTypes.object,
  handleGetClasses: PropTypes.func,
  handleGetLevels: PropTypes.func,
  getSchoolUnitsOptions: PropTypes.func.isRequired,
  getParamOptionsAcademics: PropTypes.func.isRequired,
  getClassesOptions: PropTypes.func.isRequired,
  getParamPerwakilan: PropTypes.func.isRequired,
  getPeriodsOptions: PropTypes.func.isRequired,
  handleReportSchedule: PropTypes.func.isRequired,
  handleReportSchPerunit: PropTypes.func.isRequired,
  handleReportSchPerwakilan: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  classes: PropTypes.object,
  levels: PropTypes.object,
};

LaporanJP.defaultProps = {
  handleGetCodeOfAccount: noop,
  location: {},
  handleGetClasses: noop,
  handleGetLevels: noop,
  classes: {},
  levels: {},
};
